import { lazy, Suspense } from 'react';
import type { Navigation, SheetHandle } from '@/app/contract';
import { Spinner } from '@/ui';

const Search = lazy(() => import('./Search').then(module => ({ default: module.SearchSheet })));
const NeedsYou = lazy(() => import('./NeedsYou').then(module => ({ default: module.NeedsYouSheet })));

/** Native-style direct entries preserve the current chat under the sheet. URLs use route-sheet.tsx. */
function present(nav: Navigation, kind: 'search' | 'needsYou') {
  let active = true;
  const close = (destination?: string) => {
    if (!active) return; active = false; handle.dismiss(); if (destination) nav.open(destination);
  };
  const handle: SheetHandle = nav.present(<Suspense fallback={<Spinner />}>
    {kind === 'search' ? <Search close={close} /> : <NeedsYou close={close} />}
  </Suspense>, { size: 'large', onDismiss: () => { active = false; } });
}
export const presentSearch = (nav: Navigation) => present(nav, 'search');
export const presentNeedsYou = (nav: Navigation) => present(nav, 'needsYou');
